import { useState } from 'react';
import { Store, Lock, Loader2 } from 'lucide-react';
import { useAuth } from '../providers/AuthProvider';

export function LoginPage() {
  const { login, error, isLoading } = useAuth();
  const [shopSlug, setShopSlug] = useState('');
  const [pin, setPin] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!shopSlug || !pin) return;
    await login(shopSlug.trim().toLowerCase(), pin);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary-500/20">
            <Store className="h-10 w-10 text-primary-500" />
          </div>
          <h1 className="text-2xl font-bold text-white">قيصرية</h1>
          <p className="mt-1 text-gray-400">لوحة إدارة الطابور</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Shop Slug */}
          <div>
            <label htmlFor="shopSlug" className="mb-2 block text-sm text-gray-400">
              رمز المتجر
            </label>
            <div className="relative">
              <Store className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-500" />
              <input
                id="shopSlug"
                type="text"
                value={shopSlug}
                onChange={(e) => setShopSlug(e.target.value)}
                placeholder="مثال: test-cafe"
                className="w-full rounded-xl border border-border bg-surface-light py-3 pr-10 pl-4 text-white placeholder:text-gray-500 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
                dir="ltr"
                autoComplete="off"
              />
            </div>
          </div>

          {/* PIN */}
          <div>
            <label htmlFor="pin" className="mb-2 block text-sm text-gray-400">
              رمز الدخول (PIN)
            </label>
            <div className="relative">
              <Lock className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-500" />
              <input
                id="pin"
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="****"
                maxLength={6}
                className="w-full rounded-xl border border-border bg-surface-light py-3 pr-10 pl-4 text-white placeholder:text-gray-500 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
                dir="ltr"
                autoComplete="off"
              />
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="rounded-xl bg-red-500/10 border border-red-500/30 p-3 text-center text-sm text-red-400">
              {error}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading || !shopSlug || !pin}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-500 py-3 font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin" />
                <span>جاري تسجيل الدخول...</span>
              </>
            ) : (
              'تسجيل الدخول'
            )}
          </button>
        </form>

        {/* Footer */}
        <p className="mt-8 text-center text-sm text-gray-500">
          تواصل مع مدير النظام للحصول على بيانات الدخول
        </p>
      </div>
    </div>
  );
}
